import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/stepper-input.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/stepper-input.css');
const js = require('!raw-loader!./stepperInput.js');

export const StepperInputDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css} js={js}>
    <p>
      Let&rsquo;s start off with a simple &ldquo;Stepper input&rdquo; component.
      When hooked up to some JavaScript, clicking the plus and minus buttons
      will increment and decrement the input field&rsquo;s value.
    </p>

    <p>
      Normally you would build something like this by inlining the button and
      input elements with
      <code>display: inline-block</code>
      (or maybe <code>float: left</code> if you&rsquo;re old school).
    </p>

    <p>
      But that will result in creating specific selectors for both of those
      elements. With flexbox, you won&rsquo;t need those selectors: you can
      accomplish the same effect by adding <code>display: flex</code>
      to the container.
    </p>

    <p>
      When you add this property to the container, you&rsquo;re telling that
      element, &ldquo;Hey buddy, you&rsquo;re in charge here! Lay out your
      direct descendant children according to flexbox rules.&rdquo; In their
      most basic form, these rules arrange the children along what&rsquo;s
      called the &ldquo;main axis&rdquo;, by default the x&ndash;axis, from left
      to right.
    </p>
  </DemoPage>
);

StepperInputDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/StepperInputDemo.js